const EventBus = window.EventBus;

export const NewToggleFlagSelector = {
  template: //html
  `
    <div class="flex items-center justify-center" :id="'newToogleFlagSelector_' + component">
      <span v-if="items.length" class="mr-3 text-sm font-medium text-dark new-toggle-flag-selector__text text-center">{{this.title}}</span>
      <label v-for="item in items" :for="component" class="inline-flex relative items-center cursor-pointer new-toggle-flag-selector__label">
        <input @click="handleToggle(); toggle(component, item);" type="checkbox" value="" :id="component" class="sr-only peer" v-model="isActive">
        <div
          :class="[isActive ? 'after:bg-primary' : 'after:bg-light']"
          class="w-11 h-6 bg-customGray rounded-full peer-focus:ring-blue-300 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px]  after:rounded-full after:h-5 after:w-5 after:transition-all shadow-[0px_4px_4px_rgba(0,0,0,0.25)]">
        </div>
      </label>
    </div>
  `,
  data: function () {
    return {
      show: false,
      uniqueInList: null,
      theme_directory: window.theme_directory,
      isActive: false,
      conditionSelected: '',
      selected: [],
      original_selected:[],
      loaded: false,
      enable: true,
    };
  },
  props: [
    "component",
    "title",
    "items",
    "initialSelection",
    "collapse",
    "pivot",
    "clickClosed",
    "optionsCount",
  ],
  mounted() {
    EventBus.$on("CLOSE_ALL_OPEN_COMPONENTS", () => {
      if (this.show) this.show = false;
    });
    EventBus.$on(
      "CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION",
      () => {
        this.clearSelection();
      }
    );
    EventBus.$on("NEW_TOGGLE_LIST_ABSOLUTE_ENTRY_POINT", () => {});
  },
  methods: {
    setActive(condition) {
      this.conditionSelected = condition.toLowerCase();
    },
    handleToggle() {
      this.isActive = !this.isActive;
    },
    entryPoint(items) {

     items.filter( item => {

          let replace = item.replace(/ /g, "-").replace(/---/g, "-").toLowerCase()
          let replace2 = item.replace(/ /g, "-").replace(/---/g, "-")

          if ( this.initialSelection.includes(replace) || this.initialSelection.includes(replace2) ){
            if(this.component=='condition'){
              this.selected.push(this.$t(item).toUpperCase())
            }
            else{
              this.selected.push(item.toUpperCase())
            }
            this.original_selected.push(item.toUpperCase())
          }

        }
      );

      this.$emit("updatechecked", {
        component: this.component,
        selected: this.original_selected,
      });

      this.isActive = (this.selected.length > 0);

    },
    clearSelection() {
      this.selected = [];
      this.original_selected = [];
      let componentInput = document.querySelector('#newToogleFlagSelector_' + this.component + ' input');
      if (componentInput) componentInput.checked = false;
      this.isActive = false;
      this.$emit("updatechecked", {
        component: this.component,
        selected: this.selected,
      });
    },
    display() {
      if (!this.hasItems() || !this.enable) return;
      this.show = !this.show;
    },
    hasItems() {
      return this.items.length > 0;
    },
    toggle(component, item) {
      var enabled = true;

      if (this.original_selected.length > 0 && !this.original_selected.includes(item.toUpperCase())){
        this.original_selected = [];
        this.selected = [];

        this.original_selected.push(item.toUpperCase());
        this.selected.push(item.toUpperCase());

        this.$emit("updatechecked", {
          component,
          selected: this.original_selected,
        });

        this.$emit('updatetags', {
          component,
          selected: item,
          status: enabled
        });
      } else {
        if (this.original_selected.includes(item.toUpperCase())){
          let indexSelected
          enabled = false;

          if(this.component=='condition'){
            indexSelected = this.selected.indexOf(this.$t(item).toUpperCase())
          }
          else{
            indexSelected = this.selected.indexOf(item.toUpperCase())
          }

          let indexOriginalSelected = this.original_selected.indexOf(item.toUpperCase())

          this.selected.splice(indexSelected,1);
          this.original_selected.splice(indexOriginalSelected,1);

        }
        else {
          if(this.component=='condition'){
            this.selected.push(this.$t(item).toUpperCase());
          }
          else{
            this.selected.push(item.toUpperCase());
          }

          this.original_selected.push(item.toUpperCase());
        }

        this.$emit("updatechecked", {
          component,
          selected: this.original_selected,
        });

        this.$emit('updatetags', {
          component,
          selected: item,
          status: enabled
        })
      }
    },
    log(text){
      console.log(text)
    },
    toCapitalize(text){
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    getCount(item) {
      //let newItem =this.toCapitalize(item)
      if (this.optionsCount && this.optionsCount[item.toUpperCase()])
        return `(${this.optionsCount[item.toUpperCase()]})`;
      else
        return "";
    },
    capitalizeItems(items) {
      var arrTwo = items;
      for (var i = 0; i < arrTwo.length; i++) {
        arrTwo[i] = arrTwo[i].toUpperCase().trim();
      }

      const filteredArray = arrTwo.filter(function (ele, pos) {
        return arrTwo.indexOf(ele) == pos;
      });
      return filteredArray;
    },
  },
  watch: {
    original_selected(oldVal, newVal) {
      if(oldVal !== newVal) this.$parent.removeConditionTag(newVal[0]);
      if(oldVal.length === 0 && newVal.length === 0) this.conditionSelected = '';
    },
    items(items) {

      if (!this.loaded) {
        this.entryPoint(items);
        this.loaded = true;
        // this.uppercaseItems;
      }

    },
  },
  computed: {
    disabled() {
      return !this.hasItems() || !this.enable;
    },
    isResponsive() {
      return !this.disableResponsive == true;
    },
  },
};
